import Api from "./api";

export const LOGIN_API = {
  method: "POST",
  url: "/users/login",
};

export const login = async (data) => {
  const requestBody = {
    userId: data.userId,
    password: data.password,
  };
  try {
    const response = await Api.post(LOGIN_API.url, requestBody);
    return response.data;
  } catch (error) {
    return error;
  }
};
